import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import { Logo, WhatsAppIcon } from "./Brand";
import { NAV, SITE, waLink, CATEGORIES } from "../lib/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-navy-deep text-white grain">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 pt-20 pb-10">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo />
            <p className="mt-6 max-w-sm text-slate-300 leading-relaxed">
              AdBlue (Diesel Exhaust Fluid) and lubricating oils for commercial vehicles, trucks and transport businesses — from Haldia, for India.
            </p>
            <a
              href={waLink()}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp-button"
              className="mt-8 inline-flex items-center gap-2 rounded-full border border-white/20 px-5 py-3 text-sm font-semibold transition-colors hover:border-[#25D366] hover:text-[#25D366]"
            >
              <WhatsAppIcon /> Chat on WhatsApp
            </a>
          </div>
          <div className="md:col-span-2">
            <p className="eyebrow text-brand">Explore</p>
            <ul className="mt-5 space-y-3">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="text-slate-300 hover:text-white transition-colors">{n.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="eyebrow text-brand">Categories</p>
            <ul className="mt-5 space-y-3">
              {CATEGORIES.map((c) => (
                <li key={c.id}>
                  <Link to={`/products?cat=${c.id}`} className="text-slate-300 hover:text-white transition-colors">{c.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="eyebrow text-brand">Reach us</p>
            <ul className="mt-5 space-y-4 text-slate-300">
              <li><a href={`tel:+91${SITE.headOffice}`} data-testid="footer-phone" className="flex gap-3 hover:text-white"><Phone className="h-5 w-5 text-brand shrink-0" />{SITE.headOfficeDisplay}</a></li>
              <li><a href={`tel:+91${SITE.phone}`} data-testid="footer-phone-2" className="flex gap-3 hover:text-white"><Phone className="h-5 w-5 text-brand shrink-0" />{SITE.phoneDisplay}</a></li>
              <li><a href={`mailto:${SITE.email}`} data-testid="footer-email" className="flex gap-3 hover:text-white break-all"><Mail className="h-5 w-5 text-brand shrink-0" />{SITE.email}</a></li>
              <li className="flex gap-3"><MapPin className="h-5 w-5 text-brand shrink-0" />{SITE.location}</li>
            </ul>
          </div>
        </div>
        <p aria-hidden="true" className="mt-20 font-display font-black uppercase leading-[0.8] text-[17vw] lg:text-[12.5rem] text-outline select-none whitespace-nowrap">
          Super AdBlue
        </p>
        <div className="mt-8 flex flex-col gap-3 border-t border-white/10 pt-6 text-sm text-slate-400 md:flex-row md:justify-between">
          <p>© {new Date().getFullYear()} MHM SUPER ADBLUE. All rights reserved.</p>
          <div className="flex gap-5">
            <Link to="/privacy-policy" data-testid="footer-privacy-link" className="hover:text-white">Privacy policy</Link>
            <button data-testid="footer-cookie-settings" onClick={() => window.dispatchEvent(new Event("mhm-open-consent"))} className="hover:text-white">Cookie settings</button>
            <Link to="/admin" data-testid="footer-admin-link" className="hover:text-white">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
